import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Components
const AdminDashboard = Loader(
  lazy(() => import('src/content/Home/AdminDashboard'))
);
const Sales = Loader(lazy(() => import('src/content/Home/Sales')));

const homeRoutes = [
  {
    path: '',
    element: <Navigate to="users" replace />
  },
  {
    path: 'admin-dashboard',
    element: <AdminDashboard />
  },
  {
    path: 'sales',
    element: <Sales />
  }
];

export default homeRoutes;
